export const EUROP_CUSTOMER_NUMBER = '3002064';
